module.exports = new __parcel__URL__("global-opt-in-default-image-banner.8c1c680b.svg").toString();